"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _radioUnchecked = _interopRequireDefault(require("@atlaskit/icon/core/radio-unchecked"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesPreselectedIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/></svg>`
}, props, {
  newIcon: _radioUnchecked.default
}));
MediaServicesPreselectedIcon.displayName = 'MediaServicesPreselectedIcon';
var _default = exports.default = MediaServicesPreselectedIcon;